import IconHomeActive from '../components/Layout/img/menu-account-active.svg';
import IconFansActive from '../components/Layout/img/menu-fans-active.svg';
import IconFans from '../components/Layout/img/menu-fans.svg';
import IconHome from '../components/Layout/img/menu-home.svg';
import IconProfileActive from '../components/Layout/img/menu-info-active.svg';
import IconProfile from '../components/Layout/img/menu-info.svg';
import IconMember from '../components/Layout/img/menu-member.svg';
import IconMemberActive from '../components/Layout/img/menu-member-active.svg';
import IconCoupon from '../components/Layout/img/coupon.svg';
import IconIncome from '../components/Layout/img/income.svg';
import IconServiceOrder from '../components/Layout/img/menu-service-order.svg';
import IconRecordPlayback from '../components/Layout/img/menu-record-playback.svg';
import IconHelpCenter from '../components/Layout/img/menu-help-center.svg';

export const PC_LAYOUT_PAGE = [
  '/fans',
  '/home',
  '/index',
  '/personal',
  '/news',
  '/follow',
  '/pay-qualification',
  '/member',
  '/',
  '/coupon',
  '/service-order',
  '/record-playback',
  '/income/withdraw',
  '/income/order-management',
  '/income/manage-settle-in',
];

export const HEADER_PAGE = [
  '/space',
  '/home',
  '/myticket',
  '/replay',
  '/invite',
  '/coupon/[couponId]',
  '/quick-buy/[eventId]',
  '/no-permission',
  '/create-activity',
  '/host-buy',
  '/host-buy/upgrade',
  '/name-auth',
];

export const MENU_DATA = [
  {
    group: '',
    key: 'myPlace',
    items: [
      {
        type: 'other',
        name: '主办方',
        id: 'sponsor',
      },
      {
        path: '/home',
        icon: [IconHome, IconHomeActive],
        lightIcon: [IconHome, IconHome],
        name: '活动列表',
        id: 'home',
      },
      {
        path: '/fans',
        icon: [IconFans, IconFansActive],
        lightIcon: [IconFans, IconFans],
        name: '粉丝管理',
        id: 'fans',
      },
      {
        path: '/member',
        icon: [IconMember, IconMemberActive],
        lightIcon: [IconMember, IconMember],
        name: '成员管理',
        hasPay: true,
        id: 'member',
      },
      {
        path: '/personal',
        icon: [IconProfile, IconProfileActive],
        lightIcon: [IconProfile, IconProfile],
        name: '主页资料',
        id: 'personal',
      },
      {
        type: 'subMenu',
        icon: [IconCoupon, IconCoupon],
        lightIcon: [IconCoupon, IconCoupon],
        name: '营销推广',
        id: 'marketing',
        pathList: ['/coupon'],
        items: [
          {
            path: '/coupon',
            name: '优惠券',
            id: 'coupon',
            hasPay: true,
          },
        ],
      },
      {
        type: 'subMenu',
        icon: [IconIncome, IconIncome],
        lightIcon: [IconIncome, IconIncome],
        name: '收入管理',
        id: 'income',
        // 是否是创建者才有
        isCreated: true,
        pathList: ['/income/withdraw', '/income/order-management', '/income/manage-settle-in'],
        items: [
          {
            path: '/income/order-management',
            name: '订单管理',
            id: 'order-management',
          },
          {
            path: '/income/withdraw',
            name: '提现管理',
            id: 'withdraw',
          },
          {
            path: '/income/manage-settle-in',
            name: '收款账户',
            // authCode: 'paidmeeting-order-edit-withdraw',
            id: 'settle',
            hasPay: true,
          },
        ],
      },
      {
        path: '/service-order',
        icon: [IconServiceOrder, IconServiceOrder],
        lightIcon: [IconServiceOrder, IconServiceOrder],
        name: '服务订购',
        id: 'service-order',
      },
      {
        path: '/record-playback',
        icon: [IconRecordPlayback, IconRecordPlayback],
        lightIcon: [IconRecordPlayback, IconRecordPlayback],
        name: '活动录制',
        id: 'record-playback',
      },
      {
        path: '/support/categories?catalogueId=1948',
        icon: [IconHelpCenter, IconHelpCenter],
        lightIcon: [IconHelpCenter, IconHelpCenter],
        name: '帮助中心',
        id: 'helpCenter',
        external: true,
      },
    ],
    isHost: true,
  },
];
/** 侧边栏点击按钮数据上报code */
export const MENU_REPORT: { [key: string]: string } = {
  home: 'e#eventplace_navigation#org_home_sec#click', // 主办方主页栏目点击
  personal: 'e#eventplace_navigation#info_setting_sec#click', // 主页资料
  qualification: 'e#eventplace_navigation#qualification_sec#click', // 资格申请
  order: 'e#eventplace_navigation#order_sec#click', // 订单管理
  helpCenter: 'e#eventplace_org_home#host_faq#click', // 帮助中心
};

export const LayoutProps: { [key: string]: any } = {
  '/event/[eventid]/registration': {
    className: 'pg-active-details',
    // full: true,
  },
  '/home': {
    className: 'pg-home',
    fullResponsive: true,
  },
  '/space': {
    className: 'pg-audience-home',
    full: true,
    fullResponsive: true,
  },
  '/space/share': {
    className: 'pg-mb-share',
    full: true,
    responsive: true,
  },
  '/follow': {
    classname: 'pg-sponsor-follow',
    full: true,
  },
  '/personal': {
    classname: 'pg-home-info',
    full: true,
  },
  '/fans': {
    classname: 'pg-fans-manager',
    full: true,
  },
  '/coupon': {
    classname: 'pg-coupon-manager',
  },
  '/member': {
    classname: 'pg-member-manager',
    full: true,
  },
  '/news': {
    classname: 'pg-home-info',
    full: true,
  },
  '/create': {
    full: true,
    responsive: true,
  },
  '/myticket': {
    full: true,
    className: 'myticket-page',
  },
  '/pay-qualification': {
    full: true,
    className: 'pay-qualification-page',
  },
  '/coupon/[couponId]': {
    full: true,
    className: 'event-coupon-pages',
  },
  '/quick-buy/[eventId]': {
    full: true,
    className: 'quick-buy-page',
  },
  '/invite': {
    className: 'pg-invite-details',
    full: true,
    responsive: true,
  },
  '/service-order': {
    className: 'pg-service-order',
  },
};
